import React from 'react'
import styled from 'styled-components'

import Layout from '../Layout'
import SEO from '../components/SEO'
import OneColumn from '../components/OneColumn'

import Paragraph from '../components/Paragraph'

const PrivacyHeader = styled.h5`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.colors.primary};
`

const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <SEO title="S&S Hospitality | Privacy Policy" canonical="https://www.sandshospitality.com/privacy-policy/" description='At S&S Hospitality, we value the privacy of our customers and partners. We pledge to safeguard your information in compliance with the Personal Data Ordinance of Hong Kong. ' />
      <OneColumn>
        <h1 class="page-header">Privacy Policy</h1>
        <Paragraph>
          S&S Hospitality Limited (“S&S Hospitality”) recognizes the importance
          of your privacy. This privacy statement (“this Privacy Statement”)
          explains how personal data is collected and used on
          www.sandshospitality.com (“this Website”).
          <br />
          Please read this Privacy Statement carefully. Your use of this Website
          means that you have accepted this Privacy Statement. If you are
          unwilling to be bound by the following terms, please do not use this
          Website. If you register as a member of this Website, after you have
          completed the membership registration form and pressed the button
          “submit”, it indicates that you have read and understood this Privacy
          Statement and agreed to how personal data are collected and used as
          provided in this Privacy Statement. S&S Hospitality reserves the right
          to change or modify the contents of this Website at any time and has
          the right to unilaterally change this Privacy Statement without
          notification. You should regularly visit this Website to find out
          whether this Privacy Statement has been modified, as your continued
          use of this Website indicates your acceptance of any change to this
          Privacy Statement. However, if the modification concerns how S&S Hospitality will collect and use your information (including your
          personal data) (“Data”), we will ask for your consent prior to any
          modified use. “You”, “your”, “users” and “members” refer to any person
          and/or entity that access this Website for any reason.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>1. Collection of Data and its purposes</PrivacyHeader>
        <Paragraph>
          When you use this Website and/or register as a member of this Website,
          you may have to provide to S&S Hospitality your Data including but not
          limited to your name, gender, age range, contact details and email
          address. You agree to provide to S&S Hospitality such information
          voluntarily. You agree and understand that any and all of the Data you
          provided to S&S Hospitality will be collected and used as follows:
          <br />
          <br /> (a) for verification of identity and record;
          <br />
          (b) for analysis and for comparison with others’ Data in order to
          develop S&S Hospitality products or services and market promotion
          programmes;
          <br />
          (c) to provide information to you on S&S Hospitality and various
          products and services of this Websites;
          <br />
          (d) to store communication contacting details;
          <br />
          (e) to generate survey on user traffic on this Website;
          <br />
          (f) for processing of your orders;
          <br />
          (g) for collecting payment, processing of any payment instructions and
          direct debit fees;
          <br />
          (h) for internal monitoring, including calculating any amount you
          should receive or owe, make payment to or request payment from you,
          and collecting any fees or enforcing guarantee granted to or granted
          by the users;
          <br />
          (i) daily operation of your account; and
          <br />
          (j) to implement your instruction, respond to your enquiries or those
          made in your name, and to provide efficient and responsive service.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>2. Personal Data (Privacy) Ordinance</PrivacyHeader>
        <Paragraph>
          S&S Hospitality complies with Hong Kong laws including Personal Data
          (Privacy) Ordinance in its policy and the ways it collects, uses,
          stores, discloses, transfers, protects and accesses Data.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>
          3. Retention, storage and disclosure of Data
        </PrivacyHeader>
        <Paragraph>
          You acknowledge, agree and authorize us to retain and store the Data
          you provided in one or more databases of S&S Hospitality, and to
          provide, disclose, access and t ransfer to such Data:
          <br />
          <br />
          (a) anyone of or any legal entity or department and/or associated
          company of S&S Hospitality;
          <br />
          (b) anyone who or any legal entity which has confidentiality
          obligations towards S&S Hospitality;
          <br />
          (c) S&S Hospitality employees;
          <br />
          (d) any contractor, agent or others or legal entity, or any third
          party which provides administrative, telecommunication, computer,
          payment, insurance, professional or other services to S&S Hospitality
          and is engaged by S&S Hospitality for the above purposes on collection
          of Data or relevant to the above purposes on collection of Data;
          <br />
          (e) anyone that S&S Hospitality has to make disclosure to in
          accordance with the requirements of applicable laws, administrative
          policies or regulations;
          <br />
          (f) anyone who reasonably requires S&S Hospitality to make the same
          disclosure in order that S&S Hospitality can implement the purposes
          listed in this Privacy Statement. You agree that S&S Hospitality can
          disclose your Data in the following reasonable and necessary
          circumstances:
          <br />
          (g) in compliance of relevant laws;
          <br />
          (h) to execute or implement any terms of S&S Hospitality users
          agreement;
          <br />
          (i) to protect S&S Hospitality and its users’ rights, property or
          interests; or
          <br />
          (j) in compliance with this Privacy Statement.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>4. Security of Data</PrivacyHeader>
        <Paragraph>
          S&S Hospitality will use various security technologies and procedures
          to protect your Data from unauthorized access, use or disclosure.
          Because of the nature of Internet, S&S Hospitality cannot guarantee
          the security on any transfer of Data. However, S&S Hospitality will
          take all practical and feasible measures to ensure any Data collected
          by this Website will not be intercepted by any third party. You must
          be clear that S&S Hospitality advertisers or any website with links to
          this Website may collect your Data. You must read the relevant privacy
          statement carefully before you provide your Data to them. Your
          provision of your Data to any third party has nothing to do with
          S&S Hospitality and S&S Hospitality will not have any responsibility
          on such. If S&S Hospitality receives relevant Data from a third party,
          it will retain the information in the usual strict secured and
          confidential standards.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>5. Amendment to Data</PrivacyHeader>
        <Paragraph>
          You are aware that according to Personal Data (Privacy) Ordinance, you
          have the right to access your personal data held by S&S Hospitality
          and request amendment to your personal data. If you need to access
          your personal data held by S&S Hospitality, please email to
          info@sandshospitality.com.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>6. Cookies</PrivacyHeader>
        <Paragraph>
          S&S Hospitality may use cookies on this Website. Cookies is a small
          text file that is placed on your hard disk by a Web page server.
          Cookies is not designed to use for or intended to use for accessing
          any information (except for the information on the cookies) of the
          user’s computer. On the contrary, it is an identifier placed on your
          hard disk. Cookies contain information that can later be searched by
          the same Web page server to identify a particular computer and cater
          for the use of the user and allow monitor and management of such use
          according to the information stored by that server. Therefore, cookies
          only provide to the website the information on the user’s computer and
          the website can link up such information of the cookies with other
          information such as personal identifier information. The purpose for
          this Website to use cookies is to allow automation on signing in and
          registration of information so that you are linked to the information
          for online purchase when you make purchase (if any) on this Website,
          to adjust this Website to your preferences or to personalize promotion
          or marketing. In addition, use of cookies allows S&S Hospitality to
          track the use of this Website to determine what content is useful or
          popular so that S&S Hospitality can effectively develop and improve
          this Website. You can modify your web browser on the use of cookies so
          that it will send you warning or you can decline acceptance of
          cookies. Please note this Website may not function normally or permit
          your signing in if you choose to decline acceptance of cookies.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>7. Use of Web Beacons</PrivacyHeader>
        <Paragraph>
          S&S Hospitality may use Web beacons on this Website or other websites
          and allow third party to place Web beacons on this Website to monitor
          the effectiveness of promotion or other legal purposes. Web beacons
          are also called web crawler. It is an object that is embedded in a web
          page or email which allows checking by website owner or a third party
          on whether a user has viewed the page or email. It is usually
          invisible to the user as its size is generally very small (1×1 gif)
          and has the same colour as the web page, document or email. Web
          beacons are identified as HTML IMG on web pages. Users can click on
          the information option on the web page to find out whether Web beacons
          are used on the web page. Web beacons can link to personal
          information. For example, advertising network uses web beacons to add
          on personal information the web pages a person visited and based on
          such information to add a particular kind of advertising bars. Web
          beacons can also be used to independently track the number of people
          visiting the web site.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>8. Children</PrivacyHeader>
        <Paragraph>
          This Website is intended for general audiences and does not plan or
          intend to collect Data from underage below 18. To respect the privacy
          of underage, underage below 18 should not provide any Data on this
          Website. S&S Hospitality asks that parents monitor their children when
          they surf on the web.
          <br />
          <br />
        </Paragraph>
        <PrivacyHeader>9. Member registration</PrivacyHeader>
        <Paragraph>
          S&S Hospitality will retain your Data after you register as member of
          this Website. When you provide to S&S Hospitality information which
          can verify your identity, you may receive from S&S Hospitality
          telephone calls, emails or direct promotional mail with information on
          products or services on promotion. If you do not wish to receive such
          information, please email to info@sandshospitality.com
        </Paragraph>
      </OneColumn>
    </Layout>
  )
}

export default PrivacyPolicyPage
